import useLanguage, { useDefaultFlowLanguage } from "./useLanguageFlow";
import { Translatable } from "Shared/TranslatableTextContent/translatable";
import useTranslatable from "Shared/TranslatableTextContent/hooks/useTranslatable";

type UseTranslatableParams<T> = {
  textContent: Record<string, Record<string, string>> | null; // structure is { "en": { "buttonText": "Click me" }, "es": { "buttonText": "Haga clic en mí" } }
  useFallback?: boolean; // whether to fallback to english or config defaults if no translation is present
  language?: string | null; // if not provided, will use current language from useLanguage
  translatableConfiguration?: Record<string, Translatable>; // config defaults to use if no translation is present
}

export default function useTranslatableFlow<T extends string | number | symbol>({
    textContent,
    useFallback = true,
    language = null,
    translatableConfiguration = {}
  }: UseTranslatableParams<T>): Record<T, string | null> {

  const languagePrefix = language || useLanguage()
  const defaultLanguage = useDefaultFlowLanguage()

  const translatable = useTranslatable<T>({
    textContent,
    useFallback,
    language: languagePrefix,
    translatableConfiguration,
    defaultLanguage
  })

  return  translatable
}
